// extracted by mini-css-extract-plugin
export default {"activeItem":"WSPreview-module_activeItem-xVCsL","previewContainer":"WSPreview-module_previewContainer-SKPvz","imageContainer":"WSPreview-module_imageContainer-IbnnS"};